//
import Model from '@/models/Model'

//
export default class GUser extends Model {

    /**
     * 
     */
    static appends = [
        
    ]

    /**
     * 
     */
    get full_name () {
        return [ 
            this.hr_employee.names,
            this.hr_employee.last_name1,
            this.hr_employee.last_name2,
        ].join(" ")
    }

    get hr_employee_name_case() {
        return this.getProperty('hr_employee.name_case', '-')
    }

    /**
     * 
     */
    static includes = [
        "hr_employee",
    ]

    /**
     * 
     */
    resource() {
        return 'g_user'
    }
}